import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './AnimatedGif.scss';

const ANIMATION_STATE = {
  NOT_STARTED: 'not-started',
  ANIMATING: 'animating',
  FINISHED: 'finished',
};

const AnimatedGif = ({
  successImageAltText,
  gifSrc,
  imageSrc,
  className,
  totalDuration,
  animationDuration,
  onAnimationComplete,
}) => {
  const [animationState, setAnimationState] = useState(ANIMATION_STATE.NOT_STARTED);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationState(ANIMATION_STATE.ANIMATING);
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  const close = () => {
    setTimeout(() => {
      onAnimationComplete();
    }, (totalDuration - animationDuration));
  };

  const onLoad = () => {
    setTimeout(() => {
      setAnimationState(ANIMATION_STATE.FINISHED);
      close();
    }, animationDuration);
  };

  if (animationState === ANIMATION_STATE.NOT_STARTED) {
    return null;
  }

  return (
    <>
      {animationState === ANIMATION_STATE.ANIMATING && (
        <img
          className={className || 'AnimatedGif'}
          src={gifSrc}
          alt={successImageAltText}
          onLoad={onLoad}
          data-testid="success-image-anim"
        />
      )}
      {animationState === ANIMATION_STATE.FINISHED && (
        <img
          className={className || 'AnimatedGif'}
          src={imageSrc}
          alt={successImageAltText}
          data-testid="success-image"
        />
      )}

    </>
  );
};

AnimatedGif.propTypes = {
  successImageAltText: PropTypes.string,
  gifSrc: PropTypes.string,
  imageSrc: PropTypes.string,
  className: PropTypes.string,
  totalDuration: PropTypes.number,
  animationDuration: PropTypes.number,
  onAnimationComplete: PropTypes.func.isRequired,
};

AnimatedGif.defaultProps = {
  successImageAltText: undefined,
  imageSrc: undefined,
  gifSrc: undefined,
  totalDuration: 3000,
  animationDuration: 1500,
  className: undefined,
};

AnimatedGif.displayName = 'AnimatedGif';
export default AnimatedGif;
